export const getFirstCharacter = (text: string): string => {
  const number = text.match(/^\d+/)?.[0];
  if (!number) {
    return text;
  }
  return number;
};
